export class DashboardStats {
    available_shifts: number;
    shift_warnings: number;
}
